<template>
  <div class="type-analysis-outer">
    <BlockTitle title="资产性质" />
    <div>
      <div id="typeChartDom" class="chart-canvas"></div>
    </div>
  </div>
</template>

<script>
import BlockTitle from "@/views/public_0983cc/tradeData/components/public/BlockTitle.vue";
import * as echarts from "echarts";
import "echarts-gl"; // 3d图表库
import {
  data_v2_analysis,
} from '@/api/portal'
import { mapGetters } from 'vuex'

export default {
  components: {
    BlockTitle,
  },
  data() {
    return {
      chartInstance: null,
      chartData:[],
      colorList:['#9D45D1','#1391F8','#83FFE9','#91CC75'],
      assetData: [
        
        {
          "name": "经营性资产",
          "count": 66050
        },
        {
          "name": "非经营性资产",
          "count": 40836
        },
        {
          "name": "其他",
          "count": 32
        }
      ]
    };
  },
  computed: {
    ...mapGetters(['selectLocId']),
    chartDom() {
      return document.getElementById("typeChartDom");
    },
    charOption() {
      return {
        legend: {
          bottom: '8%',
          textStyle:{
             color: "#fff",
          },
          data:  this.chartData.map(i=>{
            return {
              name:i.name,
              itemStyle:i.itemStyle
            }
          })
        },
      };
    },
  },
  watch:{
    async selectLocId(){
      await this.getAnalysis()
      this.initChart();
    }
  },
  created() {
  },
  async mounted() {
    this.calculatePercentage();
    await this.getAnalysis()
    this.$nextTick(() => {
      this.initChart();
    });
  },
  methods: {
    
    initChart() {
      var seriesData = this.chartData.map((item, index) => {
        return {
          ...item,
          actValue: item.value,
          colorBy:'series',
          label: {
            show: false,
            position: "outside",
            borderRadius: 5,
            textStyle: {
              fontSize: 14,
            },
          },
        };
      });
      // 生成扇形的曲面参数方程，用于 series-surface.parametricEquation
      function getParametricEquation(
        startRatio,
        endRatio,
        isSelected,
        isHovered,
        k,
        h
      ) {
        const midRatio = (startRatio + endRatio) / 2;
        const startRadian = startRatio * Math.PI * 2;
        const endRadian = endRatio * Math.PI * 2;
        const midRadian = midRatio * Math.PI * 2;
        // 如果只有一个扇形，则不实现选中效果。
        if (startRatio === 0 && endRatio === 1) {
          isSelected = false;
        }
        k = typeof k !== "undefined" ? k : 1 / 3;
        const offsetX = isSelected ? Math.cos(midRadian) * 0.1 : 0;
        const offsetY = isSelected ? Math.sin(midRadian) * 0.1 : 0;
        // 鼠标滑过时外环放大大小
        const hoverRate = isHovered ? 1.05 : 1;
        // 返回曲面参数方程
        return {
          u: {
            min: -Math.PI,
            max: Math.PI * 3,
            step: Math.PI / 32,
          },

          v: {
            min: 0,
            max: Math.PI * 2,
            step: Math.PI / 20,
          },

          x: function (u, v) {
            if (u < startRadian) {
              return (
                offsetX +
                Math.cos(startRadian) * (1 + Math.cos(v) * k) * hoverRate
              );
            }
            if (u > endRadian) {
              return (
                offsetX +
                Math.cos(endRadian) * (1 + Math.cos(v) * k) * hoverRate
              );
            }
            return offsetX + Math.cos(u) * (1 + Math.cos(v) * k) * hoverRate;
          },

          y: function (u, v) {
            if (u < startRadian) {
              return (
                offsetY +
                Math.sin(startRadian) * (1 + Math.cos(v) * k) * hoverRate
              );
            }
            if (u > endRadian) {
              return (
                offsetY +
                Math.sin(endRadian) * (1 + Math.cos(v) * k) * hoverRate
              );
            }
            return offsetY + Math.sin(u) * (1 + Math.cos(v) * k) * hoverRate;
          },

          z: function (u, v) {
            if (u < -Math.PI * 0.5) {
              return Math.sin(u);
            }
            if (u > Math.PI * 2.5) {
              return Math.sin(u);
            }
            return Math.sin(v) > 0 ? 60 : -1;
          },
        };
      }
      // 生成模拟 3D 饼图的配置项 // 可做为调整内环大小 0为实心圆饼图，大于0 小于1 为圆环
      function getPie3D(pieData, internalDiameterRatio) {
        const series = [];
        let sumValue = 0;
        let startValue = 0;
        let endValue = 0;
        const legendData = [];
        const k =
          typeof internalDiameterRatio !== "undefined"
            ? (1 - internalDiameterRatio) / (1 + internalDiameterRatio)
            : 1 / 3;
        for (let i = 0; i < pieData.length; i += 1) {
          sumValue += pieData[i].value;
          const seriesItem = {
            name:
              typeof pieData[i].name === "undefined"
                ? `series${i}`
                : pieData[i].name,
            type: "surface",
            parametric: true,
            wireframe: {
              show: false,
            },
            pieData: pieData[i],
            pieStatus: {
              selected: false,
              hovered: false,
              k,
            },
          };
          if (typeof pieData[i].itemStyle !== "undefined") {
            const { itemStyle } = pieData[i];
            // eslint-disable-next-line no-unused-expressions
            typeof pieData[i].itemStyle.color !== "undefined"
              ? (itemStyle.color = pieData[i].itemStyle.color)
              : null;
            // eslint-disable-next-line no-unused-expressions
            typeof pieData[i].itemStyle.opacity !== "undefined"
              ? (itemStyle.opacity = pieData[i].itemStyle.opacity)
              : null;

            seriesItem.itemStyle = itemStyle;
          }
          series.push(seriesItem);
        }
        for (let i = 0; i < series.length; i += 1) {
          endValue = startValue + series[i].pieData.value;
          series[i].pieData.startRatio = startValue / sumValue;
          series[i].pieData.endRatio = endValue / sumValue;
          series[i].parametricEquation = getParametricEquation(
            series[i].pieData.startRatio,
            series[i].pieData.endRatio,
            true,
            false,
            k,
            10 //在此处传入饼图初始高度h
          );
          startValue = endValue;
          legendData.push(series[i].name);
        }
        series.push({
          name: "pie2d",
          type: "pie",
          label: {
            show:true,
            color: "#ffffff",
            opacity: 1,
            fontStyle: "normal",
            fontSize: 12,
            fontFamily: "Microsoft YaHei",
            formatter: (params) => {
              return `${params.data.name}`;
            },
          },
          labelLine: {
            length: 30,
          },
          startAngle: -30, //起始角度，支持范围[0, 360]。
          clockwise: false, //饼图的扇区是否是顺时针排布。上述这两项配置主要是为了对齐3d的样式
          radius: ["40%", "60%"],
          center: ["100%", "80%"],
          height:'50%',
          width:'50%',
          data: pieData,
          itemStyle: {
            opacity: 0,
          },
        });

        // 准备待返回的配置项，把准备好的series 传入。
        const option = {
          title: {
            show: false,
          },
          color: [
            "rgba(111,57,244,1)",
            "rgba(217,36,242,1)",
            "rgba(51,210,186,1)",
          ],
          tooltip: {
            backgroundColor:'rgba(51,51,51,.8)',
            textStyle: {
              color: '#fff',
            },
            borderColor: 'transparent',
            formatter: (params) => {
              if (params.seriesName !== "mouseoutSeries") {
                if(!pieData[params.seriesIndex]?.value){
                  return ''
                }
                return `${params.marker}${params.seriesName}：${
                  pieData[params.seriesIndex]?.value
                }
                <br/>
                <span style="margin:0 6px"></span>占比：${pieData[params.seriesIndex].cntRate || 0 }%
                `;
              }
              return ``;
            },
          },
          xAxis3D: {
            min: -1,
            max: 1,
          },
          yAxis3D: {
            min: -1,
            max: 1,
          },
          zAxis3D: {
            min: -1,
            max: 1,
          },
          grid3D: {
            show: false,
            top: "-12%",
            boxHeight: 1, //修改立体饼图的高度
            viewControl: {
              // 3d效果可以放大、旋转等，
              alpha: 25, //饼图翻转的程度
              beta: 30,
              rotateSensitivity: 1,
              zoomSensitivity: 0,
              panSensitivity: 0,
              autoRotate: false, //是否自动旋转
              distance: 500, //距离越小看到的饼图越大
            },
          },
          series,
        };
        return option;
      }
      this.chartInstance = echarts.init(this.chartDom);
      this.chartInstance.setOption({
        legend: this.charOption.legend,
        ...getPie3D(seriesData,0)
      });
    },
    async calculatePercentage(){
      // Step 1: Calculate total count
      let totalCount = this.assetData.reduce((acc, asset) => acc + asset.count, 0);

      // Step 2: Calculate percentages and add to each object
      this.assetData.forEach(asset => {
        asset.cntRate = (asset.count / totalCount).toFixed(4); // Assuming 4 decimal places
      });
    },
    // 获取交易类型分析V2
    async getAnalysis(){
      /* let {data} = await data_v2_analysis({
        locId: this.selectLocId
      }) */
     let data = [
        {
            "name": "经营性资产",
            "count": 66050,
            "cntRate": 81.00
        },
        {
            "name": "集体经营性资产",
            "count": 11,
            "cntRate": 12.00
        },
        {
            "name": "集体资源性资产",
            "count": 3,
            "cntRate": 3.00
        },
        {
            "name": "农村小微工程",
            "count": 2,
            "cntRate": 2.00
        }
    ]
      this.chartData = this.assetData.map((i,index)=>{
        return {
          ...i,
          itemStyle:{
            color:this.colorList[index]
          },
          value:i.count,
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.type-analysis-outer {
  .chart-canvas{
    height: 190px;
  }
}
</style>